import React from "react";
import { Box, Typography, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Box
          sx={{
            p: 3,
            border: "1px dashed red",
            borderRadius: 2,
            backgroundColor: "#fff0f0",
            textAlign: "center",
            my: 2,
          }}>
          <Typography variant="h6" color="error" gutterBottom>
            Что-то пошло не так при загрузке этого блока.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Возможно, проблема связана с внешним контентом (например,
            Instagram).
          </Typography>
          {/* Only show technical details in development if needed, or hide them */}
          {process.env.NODE_ENV === "development" && (
            <Typography
              variant="caption"
              component="pre"
              sx={{
                textAlign: "left",
                bgcolor: "#eee",
                p: 1,
                overflow: "auto",
                maxHeight: 100,
              }}>
              {this.state.error && this.state.error.toString()}
            </Typography>
          )}
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleReload}
            sx={{ mt: 2 }}>
            Перезагрузить страницу
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
